import './FormEditor.css';

import React from 'react';

import {
  FormTemplate,
  isSkillField,
} from '../../types/formSchema';
import Button from '../common/Button';

export interface FormsListProps {
  templates: FormTemplate[];
  onCreateNew: () => void;
  onEdit: (template: FormTemplate) => void;
  onDelete: (templateId: string) => void;
}

function countSkills(template: FormTemplate): number {
  return template.schema.groups.reduce(
    (sum, g) => sum + g.fields.filter(isSkillField).length,
    0,
  );
}

const FormsList: React.FC<FormsListProps> = ({
  templates,
  onCreateNew,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="fe-list">
      <div className="fe-list-header-row">
        <h2 className="fe-list-title">Tryout Form Templates</h2>
        <div className="fe-list-header-actions">
          <Button type="button" variant="primary" onClick={onCreateNew}>
            Create Form
          </Button>
        </div>
      </div>

      {templates.length === 0 ? (
        <div className="fe-list-empty">
          <p className="fe-list-empty-text">
            No forms yet. Create one to use when setting up tryouts.
          </p>
        </div>
      ) : (
        <div className="fe-list-items">
          {templates.map((tpl) => (
            <div
              key={tpl.id}
              className="fe-list-item"
              onClick={() => onEdit(tpl)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onEdit(tpl);
                }
              }}
            >
              <div className="fe-list-item-info">
                <p className="fe-list-item-name">{tpl.name}</p>
                <p className="fe-list-item-meta">
                  {tpl.schema.groups.length} section
                  {tpl.schema.groups.length !== 1 ? 's' : ''}
                  {' · '}
                  {countSkills(tpl)} skill
                  {countSkills(tpl) !== 1 ? 's' : ''}
                </p>
              </div>
              <div className="fe-list-item-actions">
                <button
                  type="button"
                  className="fe-icon-btn fe-icon-btn-danger"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(tpl.id);
                  }}
                  aria-label={`Delete ${tpl.name}`}
                  title="Delete form"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M12.7 4.7l-1.4-1.4L8 6.6 4.7 3.3 3.3 4.7 6.6 8l-3.3 3.3 1.4 1.4L8 9.4l3.3 3.3 1.4-1.4L9.4 8l3.3-3.3z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FormsList;
